import { OnDestroy, Directive } from '@angular/core';
import { Subscription } from 'rxjs';

@Directive()
export class DisposableSafelly implements OnDestroy {

    protected disposableSubscriptions = new Array<Subscription>();

    public ngOnDestroy() {
        this.disposableSubscriptions.forEach((subscription) => subscription.unsubscribe());
    }
}
